// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Site documentation (/user/site-docs) */

.site-docs-page .sd-full {
  width: 100%;
}

.site-docs-page .sd-small {
  font-size: 12px;
  color: var(--ds-text-muted);
}

.site-docs-page .sd-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  overflow-wrap: anywhere;
}

.site-docs-page .sd-empty-text {
  max-width: 460px;
  margin-inline: auto;
}

.site-docs-page .sd-tag {
  margin-inline-end: 0;
  white-space: normal;
}

/* ---- List ---- */
.site-docs-page .sd-filters {
  width: 100%;
}

.site-docs-page .sd-customer-filter {
  min-width: 240px;
}

.site-docs-page .sd-list-item {
  display: flex;
  gap: var(--ds-space-3, 12px);
  align-items: flex-start;
}

.site-docs-page .sd-list-text {
  min-width: 0;
}

.site-docs-page .sd-cover {
  flex: none;
  width: 56px;
  height: 56px;
  border-radius: var(--ds-radius-sm, 6px);
  object-fit: cover;
  background: var(--ds-surface-muted);
}

.site-docs-page .sd-cover--empty {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--ds-text-muted);
  font-size: 20px;
}

/* ---- Editor ---- */
.sd-editor {
  max-width: 880px;
  margin-inline: auto;
}

.sd-editor .sd-header {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2, 8px);
  margin-bottom: var(--ds-space-3, 12px);
}

.sd-editor .sd-header-title {
  flex: 1;
  min-width: 0;
}

.sd-editor .sd-header-title h4 {
  margin: 0;
}

.sd-editor .sd-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0 var(--ds-space-3, 12px);
}

.sd-editor .sd-date {
  width: 180px;
}

.sd-editor .sd-grow {
  flex: 1;
  min-width: 200px;
}

.sd-editor .sd-notes-actions {
  margin-top: var(--ds-space-2, 8px);
}

.sd-editor .sd-mic--active {
  animation: sd-pulse 1.4s ease-in-out infinite;
}

.sd-editor .sd-interim {
  margin: var(--ds-space-2, 8px) 0 0;
  font-style: italic;
}

.sd-editor .sd-rec-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--ds-danger);
  margin-inline-end: 4px;
  animation: sd-pulse 1.4s ease-in-out infinite;
}

@keyframes sd-pulse {
  50% {
    opacity: 0.55;
  }
}

.sd-editor .sd-photo-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: var(--ds-space-3, 12px);
}

.sd-editor .sd-photo-grid figure {
  position: relative;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-1, 4px);
}

.sd-editor .sd-photo-grid .ant-image,
.sd-editor .sd-photo-grid .ant-image-img {
  width: 100%;
  aspect-ratio: 4 / 3;
  object-fit: cover;
  border-radius: var(--ds-radius-sm, 6px);
}

.sd-editor .sd-photo-grid figcaption {
  font-size: 12px;
  color: var(--ds-text-muted);
}

.sd-editor .sd-photo-remove {
  position: absolute;
  inset-block-start: 4px;
  inset-inline-end: 4px;
  background: var(--ds-surface);
  box-shadow: var(--ds-shadow-sm);
}

.sd-editor .sd-savebar {
  display: none;
}

@media (max-width: 767px) {
  .sd-editor .sd-hide-phone {
    display: none;
  }

  .sd-editor .sd-date {
    width: 100%;
  }

  .sd-editor .sd-photo-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .sd-editor .sd-section .ant-card-head-wrapper {
    flex-wrap: wrap;
    gap: var(--ds-space-2, 8px);
    padding-block: var(--ds-space-2, 8px);
  }

  /* Save, photo and delete stay at the bottom of the screen, above the bottom navigation */
  .sd-editor .sd-savebar {
    position: sticky;
    bottom: calc(var(--ds-bottomnav-h) + var(--ds-safe-bottom));
    z-index: 5;
    display: flex;
    gap: var(--ds-space-2, 8px);
    padding: var(--ds-space-2, 8px);
    margin-inline: calc(-1 * var(--ds-space-2, 8px));
    background: var(--ds-surface);
    border-top: 1px solid var(--ds-border);
    box-shadow: var(--ds-shadow-sm);
  }

  .site-docs-page .sd-customer-filter {
    min-width: 0;
    width: 100%;
  }

  .site-docs-page .sd-filters > .ant-space-item:first-child {
    flex: 1 1 100%;
  }
}

.sd-editor .sd-photo-actions {
  margin-bottom: var(--ds-space-3, 12px);
}

/* ---- Report, selection and the panel on project/offer/invoice pages ---- */
.site-docs-page .sd-selection {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2, 8px);
  padding: var(--ds-space-2, 8px) var(--ds-space-3, 12px);
  border-radius: var(--ds-radius-md, 8px);
  background: var(--ds-brand-50);
}

.site-docs-page .sd-range {
  min-width: 240px;
}

.sd-report-footer {
  justify-content: flex-end;
}

.sd-panel .sd-panel-actions {
  margin-bottom: var(--ds-space-3, 12px);
}

.sd-panel .sd-panel-item {
  cursor: pointer;
}

.sd-panel .sd-panel-item:hover {
  background: var(--ds-surface-2);
}

.sd-panel .sd-panel-list .ant-list-item {
  padding-inline: var(--ds-space-2, 8px);
}

@media (max-width: 767px) {
  .site-docs-page .sd-range {
    min-width: 0;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/serviceProvider/components/siteDocs/siteDocs.css"],"names":[],"mappings":"AAAA,yCAAyC;;AAEzC;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;;EAEE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,eAAe;IACf,2BAA2B;IAC3B,qCAAqC;EACvC;;EAEA,yFAAyF;EACzF;IACE,gBAAgB;IAChB,2DAA2D;IAC3D,UAAU;IACV,aAAa;IACb,2BAA2B;IAC3B,+BAA+B;IAC/B,gDAAgD;IAChD,6BAA6B;IAC7B,sCAAsC;IACtC,+BAA+B;EACjC;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,sCAAsC;AACxC;;AAEA,6EAA6E;AAC7E;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,uDAAuD;EACvD,uCAAuC;EACvC,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;EACb;AACF","sourcesContent":["/* Site documentation (/user/site-docs) */\n\n.site-docs-page .sd-full {\n  width: 100%;\n}\n\n.site-docs-page .sd-small {\n  font-size: 12px;\n  color: var(--ds-text-muted);\n}\n\n.site-docs-page .sd-clamp {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  overflow-wrap: anywhere;\n}\n\n.site-docs-page .sd-empty-text {\n  max-width: 460px;\n  margin-inline: auto;\n}\n\n.site-docs-page .sd-tag {\n  margin-inline-end: 0;\n  white-space: normal;\n}\n\n/* ---- List ---- */\n.site-docs-page .sd-filters {\n  width: 100%;\n}\n\n.site-docs-page .sd-customer-filter {\n  min-width: 240px;\n}\n\n.site-docs-page .sd-list-item {\n  display: flex;\n  gap: var(--ds-space-3, 12px);\n  align-items: flex-start;\n}\n\n.site-docs-page .sd-list-text {\n  min-width: 0;\n}\n\n.site-docs-page .sd-cover {\n  flex: none;\n  width: 56px;\n  height: 56px;\n  border-radius: var(--ds-radius-sm, 6px);\n  object-fit: cover;\n  background: var(--ds-surface-muted);\n}\n\n.site-docs-page .sd-cover--empty {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--ds-text-muted);\n  font-size: 20px;\n}\n\n/* ---- Editor ---- */\n.sd-editor {\n  max-width: 880px;\n  margin-inline: auto;\n}\n\n.sd-editor .sd-header {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2, 8px);\n  margin-bottom: var(--ds-space-3, 12px);\n}\n\n.sd-editor .sd-header-title {\n  flex: 1;\n  min-width: 0;\n}\n\n.sd-editor .sd-header-title h4 {\n  margin: 0;\n}\n\n.sd-editor .sd-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0 var(--ds-space-3, 12px);\n}\n\n.sd-editor .sd-date {\n  width: 180px;\n}\n\n.sd-editor .sd-grow {\n  flex: 1;\n  min-width: 200px;\n}\n\n.sd-editor .sd-notes-actions {\n  margin-top: var(--ds-space-2, 8px);\n}\n\n.sd-editor .sd-mic--active {\n  animation: sd-pulse 1.4s ease-in-out infinite;\n}\n\n.sd-editor .sd-interim {\n  margin: var(--ds-space-2, 8px) 0 0;\n  font-style: italic;\n}\n\n.sd-editor .sd-rec-dot {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--ds-danger);\n  margin-inline-end: 4px;\n  animation: sd-pulse 1.4s ease-in-out infinite;\n}\n\n@keyframes sd-pulse {\n  50% {\n    opacity: 0.55;\n  }\n}\n\n.sd-editor .sd-photo-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n  gap: var(--ds-space-3, 12px);\n}\n\n.sd-editor .sd-photo-grid figure {\n  position: relative;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-1, 4px);\n}\n\n.sd-editor .sd-photo-grid .ant-image,\n.sd-editor .sd-photo-grid .ant-image-img {\n  width: 100%;\n  aspect-ratio: 4 / 3;\n  object-fit: cover;\n  border-radius: var(--ds-radius-sm, 6px);\n}\n\n.sd-editor .sd-photo-grid figcaption {\n  font-size: 12px;\n  color: var(--ds-text-muted);\n}\n\n.sd-editor .sd-photo-remove {\n  position: absolute;\n  inset-block-start: 4px;\n  inset-inline-end: 4px;\n  background: var(--ds-surface);\n  box-shadow: var(--ds-shadow-sm);\n}\n\n.sd-editor .sd-savebar {\n  display: none;\n}\n\n@media (max-width: 767px) {\n  .sd-editor .sd-hide-phone {\n    display: none;\n  }\n\n  .sd-editor .sd-date {\n    width: 100%;\n  }\n\n  .sd-editor .sd-photo-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .sd-editor .sd-section .ant-card-head-wrapper {\n    flex-wrap: wrap;\n    gap: var(--ds-space-2, 8px);\n    padding-block: var(--ds-space-2, 8px);\n  }\n\n  /* Save, photo and delete stay at the bottom of the screen, above the bottom navigation */\n  .sd-editor .sd-savebar {\n    position: sticky;\n    bottom: calc(var(--ds-bottomnav-h) + var(--ds-safe-bottom));\n    z-index: 5;\n    display: flex;\n    gap: var(--ds-space-2, 8px);\n    padding: var(--ds-space-2, 8px);\n    margin-inline: calc(-1 * var(--ds-space-2, 8px));\n    background: var(--ds-surface);\n    border-top: 1px solid var(--ds-border);\n    box-shadow: var(--ds-shadow-sm);\n  }\n\n  .site-docs-page .sd-customer-filter {\n    min-width: 0;\n    width: 100%;\n  }\n\n  .site-docs-page .sd-filters > .ant-space-item:first-child {\n    flex: 1 1 100%;\n  }\n}\n\n.sd-editor .sd-photo-actions {\n  margin-bottom: var(--ds-space-3, 12px);\n}\n\n/* ---- Report, selection and the panel on project/offer/invoice pages ---- */\n.site-docs-page .sd-selection {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2, 8px);\n  padding: var(--ds-space-2, 8px) var(--ds-space-3, 12px);\n  border-radius: var(--ds-radius-md, 8px);\n  background: var(--ds-brand-50);\n}\n\n.site-docs-page .sd-range {\n  min-width: 240px;\n}\n\n.sd-report-footer {\n  justify-content: flex-end;\n}\n\n.sd-panel .sd-panel-actions {\n  margin-bottom: var(--ds-space-3, 12px);\n}\n\n.sd-panel .sd-panel-item {\n  cursor: pointer;\n}\n\n.sd-panel .sd-panel-item:hover {\n  background: var(--ds-surface-2);\n}\n\n.sd-panel .sd-panel-list .ant-list-item {\n  padding-inline: var(--ds-space-2, 8px);\n}\n\n@media (max-width: 767px) {\n  .site-docs-page .sd-range {\n    min-width: 0;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
